/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface OpenBalanceDetailResponse
 */
export interface OpenBalanceDetailResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof OpenBalanceDetailResponse
     */
    balanceDetailId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {number}
     * @memberof OpenBalanceDetailResponse
     */
    debitAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OpenBalanceDetailResponse
     */
    coveredAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OpenBalanceDetailResponse
     */
    remainingAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof OpenBalanceDetailResponse
     */
    currencyDate: Date;
    /**
     * 
     * @type {string}
     * @memberof OpenBalanceDetailResponse
     */
    description: string | null;
}

/**
 * Check if a given object implements the OpenBalanceDetailResponse interface.
 */
export function instanceOfOpenBalanceDetailResponse(value: object): value is OpenBalanceDetailResponse {
    if (!('balanceDetailId' in value) || value['balanceDetailId'] === undefined) return false;
    if (!('debitAmount' in value) || value['debitAmount'] === undefined) return false;
    if (!('coveredAmount' in value) || value['coveredAmount'] === undefined) return false;
    if (!('remainingAmount' in value) || value['remainingAmount'] === undefined) return false;
    if (!('currencyDate' in value) || value['currencyDate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function OpenBalanceDetailResponseFromJSON(json: any): OpenBalanceDetailResponse {
    return OpenBalanceDetailResponseFromJSONTyped(json, false);
}

export function OpenBalanceDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenBalanceDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'balanceDetailId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['balanceDetailId']),
        'debitAmount': json['debitAmount'],
        'coveredAmount': json['coveredAmount'],
        'remainingAmount': json['remainingAmount'],
        'currencyDate': (new Date(json['currencyDate'])),
        'description': json['description'],
    };
}

export function OpenBalanceDetailResponseToJSON(json: any): OpenBalanceDetailResponse {
    return OpenBalanceDetailResponseToJSONTyped(json, false);
}

export function OpenBalanceDetailResponseToJSONTyped(value?: OpenBalanceDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balanceDetailId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['balanceDetailId']),
        'debitAmount': value['debitAmount'],
        'coveredAmount': value['coveredAmount'],
        'remainingAmount': value['remainingAmount'],
        'currencyDate': value['currencyDate'].toISOString().substring(0,10),
        'description': value['description'],
    };
}

